import React from "react";
import {
    DataGrid,
    HeaderFilter,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    Lookup,
    Format,
    FormItem,
} from "devextreme-react/data-grid";
import uiInfo from "../ui-info";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarEscoreDs, criarFatorCorretivoDs } from "../DataSources";
import UserInfo from "../UserInfo";

export default class AliquotaIssBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
        this.tiposFatores = [
            { id: "T", descricao: "Terreno" },
            { id: "E", descricao: "Edificação" },
            { id: "S", descricao: "Segmento" }
        ];
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="ESCORES">
                    <DataGrid
                        dataSource={criarEscoreDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        columnAutoWidth={true}
                        focusedRowEnabled={true}
                        onInitNewRow={this.initNewRow}>
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <Editing mode={"popup"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                        <Column dataField={"id"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={'fatorId'} caption={"Fator"}>
                            <Lookup
                                dataSource={criarFatorCorretivoDs()}
                                valueExpr={"id"}
                                displayExpr={"descricao"} />
                        </Column>
                        <Column dataField={'nome'} caption={"Escore"} />
                        <Column dataField={'comando'} caption={"Comando"} />
                        <Column dataField={'fator'} caption={"Peso"}>
                            <Format type={"fixedPoint"} precision={4} />
                        </Column>

                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }
}